// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../shared/Ui.re.mjs";
import * as React from "react";
import * as Layout from "../shared/Layout.re.mjs";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@linaria/core";
import ExchangeSvg from "./exchange.svg";
import ShippingSvg from "./shipping.svg";
import WarrantySvg from "./warranty.svg";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactHelmetAsync from "react-helmet-async";

import { cx } from '@linaria/core'
;

var shippingIcon = ShippingSvg;

var warrantyIcon = WarrantySvg;

var exchangeIcon = ExchangeSvg;

var RRLocation = {};

var incentives = [
  {
    name: "Free shipping",
    imageSrc: shippingIcon,
    description: "If it's bigger than 12\"x12\" we'll cover the shipping cost of our Economy Saver Shipping option."
  },
  {
    name: "Money Back Guarantee",
    imageSrc: warrantyIcon,
    description: "If you don't like you  artwork for any reason (it happens), we'll refund your money if you tried at least one revision with the artist. Just contact us within 30 days of receiving your painting."
  },
  {
    name: "Unlimited Revisions",
    imageSrc: exchangeIcon,
    description: "Tweak and adjust your artwork as long as you are able to describe the specific changes you want made to the finished painting."
  }
];

function Landing$Incentives(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h2", {
                                          children: "Why Choose Instapainting?",
                                          className: Core.cx("text-4xl font-extrabold tracking-tight text-gray-900")
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "We've been doing this since 2014, and built up a reputation deliverying thousands of orders for Christmas, weddings, pet birthday's and more. We've fulfilled orders for Alexis Ohanian (founder of Reddit.com), as well as for ordinaray people all around the world from Alabama to Tokyo.",
                                          className: Core.cx("mt-4 text-gray-500")
                                        })
                                  ],
                                  className: Core.cx("max-w-3xl")
                                }),
                            JsxRuntime.jsx("div", {
                                  children: Belt_Array.map(incentives, (function (incentive) {
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx(Ui.Img.make, {
                                                                    src: incentive.imageSrc,
                                                                    className: Core.cx("w-16 h-16"),
                                                                    alt: incentive.name
                                                                  }),
                                                              className: Core.cx("sm:flex-shrink-0")
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("h3", {
                                                                      children: incentive.name,
                                                                      className: Core.cx("text-sm font-medium text-gray-900")
                                                                    }),
                                                                JsxRuntime.jsx("p", {
                                                                      children: incentive.description,
                                                                      className: Core.cx("mt-2 text-sm text-gray-500")
                                                                    })
                                                              ],
                                                              className: Core.cx("mt-4 sm:mt-0 sm:ml-6 lg:mt-6 lg:ml-0")
                                                            })
                                                      ],
                                                      className: Core.cx("sm:flex lg:block")
                                                    }, incentive.name);
                                        })),
                                  className: Core.cx("mt-16 grid grid-cols-1 gap-y-10 gap-x-8 lg:grid-cols-3")
                                })
                          ],
                          className: Core.cx("max-w-2xl mx-auto px-4 lg:max-w-none")
                        }),
                    className: Core.cx("max-w-7xl mx-auto py-24 sm:px-2 sm:py-32 lg:px-4")
                  }),
              className: Core.cx("bg-white")
            });
}

var Incentives = {
  make: Landing$Incentives
};

function Landing$Incentives2(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("h2", {
                                              children: "Why Choose Instapainting?",
                                              className: Core.cx("text-2xl font-extrabold tracking-tight text-gray-900")
                                            }),
                                        className: Core.cx("text-center")
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: Belt_Array.map(incentives, (function (incentive) {
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("div", {
                                                                    children: JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx(Ui.Img.make, {
                                                                                src: incentive.imageSrc,
                                                                                className: Core.cx("w-16 h-16 mx-auto"),
                                                                                alt: incentive.name
                                                                              }),
                                                                          className: Core.cx("flow-root")
                                                                        }),
                                                                    className: Core.cx("sm:flex-shrink-0")
                                                                  }),
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx("h3", {
                                                                            children: incentive.name,
                                                                            className: Core.cx("text-sm font-medium text-gray-900")
                                                                          }),
                                                                      JsxRuntime.jsx("p", {
                                                                            children: incentive.description,
                                                                            className: Core.cx("mt-2 text-sm text-gray-500")
                                                                          })
                                                                    ],
                                                                    className: Core.cx("mt-3 sm:mt-0 sm:ml-6 lg:mt-6 lg:ml-0")
                                                                  })
                                                            ],
                                                            className: Core.cx("text-center sm:flex sm:text-left lg:block lg:text-center")
                                                          }, incentive.name);
                                              })),
                                        className: Core.cx("mt-12 max-w-sm mx-auto grid grid-cols-1 gap-y-10 gap-x-8 sm:max-w-none lg:grid-cols-3")
                                      })
                                ],
                                className: Core.cx("max-w-xl mx-auto lg:max-w-none")
                              }),
                          className: Core.cx("bg-gray-50 rounded-2xl px-6 py-16 sm:p-16")
                        }),
                    className: Core.cx("max-w-7xl mx-auto px-4 py-6 lg:py-8 sm:px-6 lg:px-8")
                  }),
              className: Core.cx("bg-white")
            });
}

var Incentives2 = {
  make: Landing$Incentives2
};

function Landing$CallToAction(props) {
  var alt = props.alt;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("h2", {
                            children: [
                              JsxRuntime.jsx("a", {
                                    children: JsxRuntime.jsx("span", {
                                          children: "Over 7000 Reviews.",
                                          className: Core.cx("block")
                                        }),
                                    className: Core.cx("text-gray-900"),
                                    href: "/reviews"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: "Over 30,000 Pieces Commissioned",
                                    className: Core.cx("block text-primary-900")
                                  })
                            ],
                            className: Core.cx("text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl")
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("a", {
                                                  children: "Upload a Photo",
                                                  className: Core.cx("inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-900 hover:bg-primary-800"),
                                                  href: "/assets"
                                                }),
                                            className: Core.cx("inline-flex rounded-md shadow")
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("a", {
                                                  children: alt.text,
                                                  className: Core.cx("inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary-900 bg-white hover:bg-indigo-50"),
                                                  href: alt.link
                                                }),
                                            className: Core.cx("ml-3 inline-flex rounded-md shadow")
                                          })
                                    ],
                                    className: Core.cx("mt-8 flex lg:mt-0 lg:flex-shrink-0")
                                  }),
                              JsxRuntime.jsxs("a", {
                                    children: [
                                      "Browse more reviews",
                                      JsxRuntime.jsx("span", {
                                            children: " \u2192",
                                            "aria-hidden": true
                                          })
                                    ],
                                    className: Core.cx("mt-2 text-sm font-semibold text-primary-900 hover:text-primary-800 lg:text-right"),
                                    href: "/reviews"
                                  })
                            ],
                            className: Core.cx("flex flex-col")
                          })
                    ],
                    className: Core.cx("max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between")
                  }),
              className: Core.cx("bg-gray-50 my-12 lg:my-16")
            });
}

var CallToAction = {
  make: Landing$CallToAction
};

function Landing$Content(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("h2", {
                                  children: [
                                    JsxRuntime.jsx("span", {
                                          children: props.title1,
                                          className: Core.cx("block text-base text-center text-primary-900 font-semibold tracking-wide uppercase")
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: props.title2,
                                          className: Core.cx("mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl")
                                        })
                                  ]
                                }),
                            JsxRuntime.jsx("p", {
                                  children: props.children,
                                  className: Core.cx("mt-8 text-xl text-gray-500 leading-8")
                                })
                          ],
                          className: Core.cx("text-lg max-w-prose mx-auto")
                        }),
                    className: Core.cx("relative px-0 sm:px-0 lg:px-0")
                  }),
              className: Core.cx("relative py-6 lg:py-8 bg-white overflow-hidden")
            });
}

var Content = {
  make: Landing$Content
};

function Landing$Testimonial(props) {
  var testimonial = props.testimonial;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Ui.Picture.make, {
                                              src: testimonial.image,
                                              className: Core.cx("absolute inset-0 h-full w-full rounded-2xl object-cover shadow-2xl"),
                                              sources: {
                                                sources: [
                                                  {
                                                    htmlAttributes: {
                                                      media: "(min-width: 1536px)"
                                                    },
                                                    imgixParams: {
                                                      fit: "crop",
                                                      crop: "faces"
                                                    },
                                                    width: 384,
                                                    height: 496,
                                                    sizes: undefined
                                                  },
                                                  {
                                                    htmlAttributes: {
                                                      media: "(min-width: 1280px)"
                                                    },
                                                    imgixParams: {
                                                      fit: "crop",
                                                      crop: "faces"
                                                    },
                                                    width: 363,
                                                    height: 528,
                                                    sizes: undefined
                                                  },
                                                  {
                                                    htmlAttributes: {
                                                      media: "(min-width: 1024px)"
                                                    },
                                                    imgixParams: {
                                                      fit: "crop",
                                                      crop: "faces"
                                                    },
                                                    width: 277,
                                                    height: 560,
                                                    sizes: undefined
                                                  },
                                                  {
                                                    htmlAttributes: {
                                                      media: "(min-width: 768px)"
                                                    },
                                                    imgixParams: {
                                                      fit: "crop",
                                                      crop: "faces"
                                                    },
                                                    width: 672,
                                                    height: 294,
                                                    sizes: undefined
                                                  },
                                                  {
                                                    htmlAttributes: {
                                                      media: "(min-width: 640px)"
                                                    },
                                                    imgixParams: {
                                                      fit: "crop",
                                                      crop: "faces"
                                                    },
                                                    width: 544,
                                                    height: 238,
                                                    sizes: undefined
                                                  }
                                                ],
                                                default: {
                                                  width: 416,
                                                  height: 250,
                                                  sizes: undefined,
                                                  imgixParams: {
                                                    fit: "crop",
                                                    crop: "faces"
                                                  }
                                                }
                                              },
                                              alt: testimonial.imageAlt
                                            }),
                                        className: Core.cx("relative aspect-[2/1] h-full md:-mx-8 xl:mx-0 xl:aspect-auto")
                                      }),
                                  className: Core.cx("-mt-8 w-full max-w-2xl xl:-mb-8 xl:w-96 xl:flex-none")
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("blockquote", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("svg", {
                                                        children: JsxRuntime.jsx("path", {
                                                              d: "M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                                                            }),
                                                        "aria-hidden": true,
                                                        className: Core.cx("h-12 w-12 text-white opacity-25"),
                                                        fill: "currentColor",
                                                        viewBox: "0 0 32 32"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: testimonial.review,
                                                        className: Core.cx("mt-6 text-2xl font-medium text-white")
                                                      })
                                                ]
                                              }),
                                          JsxRuntime.jsxs("footer", {
                                                children: [
                                                  JsxRuntime.jsx("p", {
                                                        children: testimonial.name,
                                                        className: Core.cx("text-base font-medium text-white")
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: testimonial.location,
                                                        className: Core.cx("text-base font-medium text-indigo-100")
                                                      })
                                                ],
                                                className: Core.cx("mt-6")
                                              })
                                        ],
                                        className: "text-xl font-semibold leading-8 text-white sm:text-2xl sm:leading-9"
                                      }),
                                  className: Core.cx("w-full max-w-2xl xl:max-w-none xl:flex-auto xl:px-16 xl:py-24")
                                })
                          ],
                          className: Core.cx("mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch")
                        }),
                    className: Core.cx("bg-primary-900 pb-20 sm:pb-24 xl:pb-0")
                  }),
              className: Core.cx("pb-16 pt-24 sm:pb-24 sm:pt-32 xl:pb-32")
            });
}

var Testimonial = {
  make: Landing$Testimonial
};

function card_of_product(product) {
  return {
          title: product.title,
          subtitle: "Starting at $" + String(product.price),
          src: product.src,
          imageAlt: product.imageAlt,
          link: "/products/" + product.sku
        };
}

function Landing$ProductCardCarousel(props) {
  var cards = Belt_Array.map(props.products, card_of_product);
  return JsxRuntime.jsx(Ui.CardCarousel.make, {
              cards: cards,
              title: "Explore Your Options",
              moreText: "Browse all products",
              moreLink: "/products"
            });
}

var ProductCardCarousel = {
  card_of_product: card_of_product,
  make: Landing$ProductCardCarousel
};

function Landing$AboutArtists(props) {
  var youtubeVideo = props.youtubeVideo;
  var gridStyles = youtubeVideo !== undefined ? Core.cx("grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 place-items-center") : Core.cx("grid grid-cols-1 gap-4 place-items-center");
  return JsxRuntime.jsxs(Layout.Container.make, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Landing$Content, {
                              title1: "About our",
                              title2: "Artists",
                              children: "We are an open platform for all artists around the world. When you submit an order you are matched with an independent artist who makes the art by hand from their home and ships it to your door."
                            }),
                        Belt_Option.getWithDefault(Belt_Option.map(youtubeVideo, (function (url) {
                                    return JsxRuntime.jsx("iframe", {
                                                className: Core.cx("max-w-full"),
                                                allowFullScreen: true,
                                                height: "315",
                                                src: url,
                                                width: "560"
                                              });
                                  })), null)
                      ],
                      className: gridStyles
                    }),
                JsxRuntime.jsx(Landing$Incentives2, {})
              ],
              className: Core.cx("mt-12 sm:mt-16")
            });
}

var AboutArtists = {
  make: Landing$AboutArtists
};

function Landing$LandingPage(props) {
  var products = props.products;
  var altCta = props.altCta;
  var mainCta = props.mainCta;
  var heroImg = props.heroImg;
  var $$location = ReactRouterDom.useLocation();
  var getPrice = function (product) {
    return product.price;
  };
  var getDefaultPrice = function (products) {
    return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(products, 0), getPrice), 0);
  };
  var lowestPriceItem = Belt_Array.reduce(products, getDefaultPrice(products), (function (acc, product) {
          if (product.price < acc) {
            return product.price;
          } else {
            return acc;
          }
        }));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(ReactHelmetAsync.Helmet, {
                      children: React.cloneElement(JsxRuntime.jsx("script", {
                                defer: true,
                                src: "https://widget.gista.co/embed.min.js"
                              }), {
                            "data-id": "c-uOssM62Iow2Njm58NpiKHm"
                          })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
                              children: [
                                JsxRuntime.jsx("title", {
                                      children: props.pageTitle
                                    }),
                                JsxRuntime.jsx("meta", {
                                      content: props.metaDescription,
                                      name: "description"
                                    }),
                                JsxRuntime.jsx("link", {
                                      href: "https://www.instapainting.com" + $$location.pathname,
                                      rel: "canonical"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx(Ui.Hero2.make, {
                              title: props.title,
                              title2: props.title2 + " from $" + String(lowestPriceItem),
                              description: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                    children: [
                                      props.description,
                                      JsxRuntime.jsx("em", {
                                            children: " Just upload a photo to get started."
                                          })
                                    ]
                                  }),
                              action1: JsxRuntime.jsx("a", {
                                    children: mainCta.text,
                                    href: mainCta.link
                                  }),
                              action2: JsxRuntime.jsx("a", {
                                    children: altCta.text,
                                    href: altCta.link
                                  }),
                              image: JsxRuntime.jsx(Ui.Picture.make, {
                                    src: heroImg.src,
                                    className: Core.cx("absolute inset-0 w-full h-full object-cover"),
                                    sources: {
                                      sources: [{
                                          htmlAttributes: {
                                            media: "(min-width: 1024px)"
                                          },
                                          imgixParams: undefined,
                                          width: 607,
                                          height: 770,
                                          sizes: "50vw"
                                        }],
                                      default: {
                                        width: 672,
                                        height: 288,
                                        sizes: "100vw",
                                        imgixParams: undefined
                                      }
                                    },
                                    imgixParams: {
                                      fit: "crop",
                                      crop: "focalpoint"
                                    },
                                    alt: heroImg.alt,
                                    lazyLoad: false
                                  })
                            }),
                        Belt_Option.getWithDefault(Belt_Option.map(props.secondaryContent, (function (secondaryContent) {
                                    return JsxRuntime.jsx(Layout.Container.make, {
                                                children: JsxRuntime.jsx(Landing$Content, {
                                                      title1: secondaryContent.title1,
                                                      title2: secondaryContent.title2,
                                                      children: secondaryContent.body
                                                    }, secondaryContent.title1)
                                              });
                                  })), null),
                        JsxRuntime.jsx(Ui.HalfBg.make, {
                              children: JsxRuntime.jsx(Layout.Container.make, {
                                    children: JsxRuntime.jsx(Landing$ProductCardCarousel, {
                                          products: products
                                        }),
                                    className: Core.cx("pt-12 lg:pt-16")
                                  }),
                              callToAction: Caml_option.some(JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("h2", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "Start your order with",
                                                        className: Core.cx("block")
                                                      }),
                                                  JsxRuntime.jsx("span", {
                                                        children: "just a 20% deposit.",
                                                        className: Core.cx("block italic")
                                                      })
                                                ],
                                                className: Core.cx("text-3xl font-extrabold tracking-tight text-gray-200 sm:text-4xl")
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("a", {
                                                              children: mainCta.text,
                                                              className: Core.cx("inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-900 hover:bg-primary-800"),
                                                              href: mainCta.link
                                                            }),
                                                        className: Core.cx("inline-flex rounded-md shadow")
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("a", {
                                                              children: altCta.text,
                                                              className: Core.cx("inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary-900 bg-indigo-100 hover:bg-indigo-200"),
                                                              href: altCta.link
                                                            }),
                                                        className: Core.cx("ml-3 inline-flex")
                                                      })
                                                ],
                                                className: Core.cx("mt-8 flex justify-center")
                                              })
                                        ],
                                        className: Core.cx("max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8")
                                      }))
                            }),
                        JsxRuntime.jsx(Landing$AboutArtists, {
                              youtubeVideo: props.youtubeVideo
                            }),
                        JsxRuntime.jsxs(Layout.Container.make, {
                              children: [
                                Belt_Array.map(props.reviews, (function (testimonial) {
                                        return JsxRuntime.jsx(Landing$Testimonial, {
                                                    testimonial: testimonial
                                                  }, testimonial.image);
                                      })),
                                JsxRuntime.jsx(Landing$CallToAction, {
                                      alt: altCta
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: Belt_Array.map(props.contentBlocks, (function (param) {
                                              var title1 = param.title1;
                                              return JsxRuntime.jsx(Landing$Content, {
                                                          title1: title1,
                                                          title2: param.title2,
                                                          children: param.body
                                                        }, title1);
                                            })),
                                      className: Core.cx("lg:grid lg:grid-cols-2 lg:gap-6")
                                    })
                              ]
                            })
                      ],
                      className: Core.cx("bg-white")
                    })
              ]
            });
}

var LandingPage = {
  make: Landing$LandingPage
};

export {
  shippingIcon ,
  warrantyIcon ,
  exchangeIcon ,
  RRLocation ,
  incentives ,
  Incentives ,
  Incentives2 ,
  CallToAction ,
  Content ,
  Testimonial ,
  ProductCardCarousel ,
  AboutArtists ,
  LandingPage ,
}
/*  Not a pure module */
